import { render, staticRenderFns } from "./symbolModal.vue?vue&type=template&id=1c31a030&scoped=true&"
import script from "./symbolModal.vue?vue&type=script&lang=js&"
export * from "./symbolModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31a030",
  null
  
)

export default component.exports